import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import Head from 'next/head';
import { getAllPageSlugs, getPageData } from '@/util/legalPages';

const LegalPage = ({ pageData }) => {
  return (
    <>
      <Head>
        <title>{pageData.title} - Structure</title>
      </Head>

      <div className="mx-auto mb-12 flex flex-col px-4 text-left">
        <article
          className="prose prose-sm mt-12 prose-headings:font-medium prose-a:font-normal prose-a:text-blue-3 prose-a:decoration-transparent prose-strong:font-medium"
          /* eslint-disable-next-line react/no-danger */
          dangerouslySetInnerHTML={{ __html: pageData.contentHtml }}
        />
      </div>
    </>
  );
};

export async function getStaticPaths({ locales }) {
  const paths = getAllPageSlugs(locales);

  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps({ locale, params: { page } }) {
  const pageData = await getPageData(page, locale);

  return {
    props: {
      pageData,
      ...(await serverSideTranslations(locale, ['common', 'homepage', 'footer'])),
    },
  };
}

export default LegalPage;
